export default "__VITE_ASSET__5c967483__"